"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'PoliticaPrivacidade',
  data: function data() {
    return {
      secoes: [{
        titulo: '1. Introdução',
        conteudo: 'A PLANTOO reforça seu compromisso com a privacidade e proteção dos dados pessoais, conforme a LGPD (Lei nº 13.709/2018).'
      }, {
        titulo: '2. Definições',
        conteudo: 'Termos como titular, controlador, operador, dados pessoais e sensíveis, tratamento, DPO, entre outros, estão definidos conforme a LGPD.'
      }, {
        titulo: '3. Escopo e Aplicabilidade',
        conteudo: 'Aplica-se a todos os profissionais, parceiros, terceiros e titulares de dados cujas informações são tratadas pela empresa.'
      }, {
        titulo: '4. Princípios de Tratamento',
        conteudo: '<ul><li>Finalidade</li><li>Adequação</li><li>Necessidade</li><li>Livre acesso</li><li>Qualidade dos dados</li><li>Transparência</li><li>Segurança</li><li>Prevenção</li><li>Não discriminação</li><li>Responsabilização</li></ul>'
      }, {
        titulo: '5. Bases Legais',
        conteudo: 'O tratamento ocorre com base em consentimento, execução contratual, cumprimento legal, legítimo interesse, entre outros.'
      }, {
        titulo: '6. Direitos dos Titulares',
        conteudo: 'Incluem acesso, correção, exclusão, portabilidade, revogação do consentimento, entre outros.'
      }, {
        titulo: '7. Compartilhamento de Dados',
        conteudo: 'Realizado de forma restrita, com base na finalidade e mínima necessidade, garantindo segurança e conformidade contratual com terceiros.'
      }, {
        titulo: '8. Segurança e Incidentes',
        conteudo: 'Medidas técnicas e administrativas são adotadas para prevenir incidentes. Em caso de suspeita, acione o DPO via <a href="mailto:compliance@fiboo.com.br">compliance@fiboo.com.br</a>.'
      }, {
        titulo: '9. Atualização e Treinamento',
        conteudo: 'Normativos são revisados periodicamente e todos os envolvidos devem participar de treinamentos oferecidos pela empresa.'
      }]
    };
  }
};